
import React from 'react'

const CANCEL_REVIEW_TEXT = 'Cancel review'
const SUBMIT_REVIEW_TEXT = 'Submit review'
const SUBMITTING_TEXT = 'Submitting...'

const ReviewButtons = ({ onClose, handleSubmitReview, isFormValid, loading }) => {
  return (
    <div className='review-button-container'>
      <button
        type='submit'
        className='write-review-cancel-button'
        onClick={onClose}
      >
        {CANCEL_REVIEW_TEXT}
      </button>
      <button
        type='submit'
        className={`submit-review-button ${!isFormValid() ? 'submit-review-button--disabled' : ''}`}
        onClick={handleSubmitReview}
        disabled={!isFormValid()}
      >
        {loading ? SUBMITTING_TEXT : SUBMIT_REVIEW_TEXT}
      </button>
    </div>
  )
}

export default ReviewButtons
